<template>
	<div>
		<div class="basic-container">
			<div class="info-tab-box">
				<div class="tab-title">
					<div class="tab-btn">
						<a class="title" :class="viewType === 'info' ? 'tab-txt-click' : ''" @click="moveTab('info')">
							<img
								:src="
									viewType === 'info'
										? require('../../assets/images/icon/icon-info2@2x.png')
										: require('../../assets/images/icon/icon-info2-no@2x.png')
								"
							/>
							회사정보</a
						>
						<a class="title" :class="viewType === 'personnel' ? 'tab-txt-click' : ''" @click="moveTab('personnel')">
							<img
								:src="
									viewType === 'personnel'
										? require('../../assets/images/icon/icon-info1@2x.png')
										: require('../../assets/images/icon/icon-info1-no@2x.png')
								"
							/>
							담당자정보</a
						>
						<a class="title" :class="viewType === 'payment' ? 'tab-txt-click' : ''" @click="moveTab('payment')">
							<img
								:src="
									viewType === 'payment'
										? require('../../assets/images/icon/icon-info3@2x.png')
										: require('../../assets/images/icon/icon-info3-no@2x.png')
								"
							/>
							기업부담금</a
						>
					</div>
					<button class="lineBtn" @click="oktaInfo">내정보 수정하기</button>
				</div>

				<div class="tab-title web-hide">
					<a class="title" :class="viewType === 'info' ? 'tab-txt-click' : ''" @click="moveTab('info')">회원정보</a>
					<a class="title" :class="viewType === 'personnel' ? 'tab-txt-click' : ''" @click="moveTab('personnel')">담당자정보</a>
					<a class="title" :class="viewType === 'payment' ? 'tab-txt-click' : ''" @click="moveTab('payment')">기업부담금</a>
				</div>
			</div>

			<form name="form" id="companyForm" method="post" enctype="multipart/form-data">
				<section class="mypage-info-area" v-show="viewType == 'info'">
					<div class="block half">
						<label>새싹기업명</label>
						<input type="text" name="companyNmKor" v-model="apiData.companyNmKor" readonly disabled />
					</div>
					<div class="block half">
						<label class="text-right">아이디</label>
						<input type="text" name="userId" v-model="apiData.userId" readonly disabled />
					</div>
					<div class="block half">
						<label>소속TP</label>
						<input type="text" name="businessTpNm" v-model="businessTpNm" readonly disabled />
					</div>
					<div class="block half">
						<label class="text-right">대표자명</label>
						<input type="text" name="ceoNmKor" v-model="apiData.ceoNmKor" readonly disabled />
					</div>
					<div class="block half">
						<label>대표전화번호</label>
						<input type="text" name="companyLandline" v-model="apiData.companyLandline" readonly disabled />
					</div>
					<div class="block half">
						<label class="text-right">대표이메일</label>
						<input type="text" name="ceoEmail" v-model="apiData.ceoEmail" readonly disabled />
					</div>
					<div class="block half">
						<label>휴대폰</label>
						<input type="text" name="ceoLandline" v-model="apiData.ceoLandline" readonly disabled />
					</div>
					<div class="block half">
						<label class="text-right">설립연도</label>
						<input type="text" name="foundYear" v-model="apiData.foundYear" readonly disabled />
					</div>
					<div class="block half">
						<label>사업자등록번호</label>
						<input type="text" name="registrationNo" v-model="registrationNo" readonly disabled />
					</div>
					<div class="block half">
						<label class="text-right">업종</label>
						<input type="text" name="businessTypeNm" v-model="apiData.businessTypeNm" readonly disabled />
					</div>
					<div class="block half">
						<label>세부품목</label>
						<input type="text" name="mainGoods" v-model="apiData.mainGoods" readonly disabled />
					</div>
					<div class="block half">
						<label class="text-right">수출희망품목</label>
						<input type="text" name="exportProduct" v-model="apiData.exportProduct" readonly disabled />
					</div>
					<div class="block half">
						<label>우편번호</label>
						<input type="text" name="postNo" v-model="apiData.postNo" readonly disabled />
					</div>
					<div class="block half mobile-hide"></div>
					<div class="block">
						<label>주소</label>
						<input type="text" name="companyAddress" v-model="apiData.companyAddress" readonly disabled />
					</div>
					<div class="block">
						<label>홈페이지</label>
						<input type="text" name="website" v-model="apiData.website" readonly disabled />
					</div>
					<div class="block">
						<label class="label-top">회사소개</label>
						<textarea name="introCompany" v-model="apiData.introCompany" readonly disabled />
					</div>
				</section>

				<section class="mypage-info-area" v-show="viewType === 'personnel'">
					<div class="block half">
						<label>성명</label>
						<input type="text" name="dutyNmKor" v-model="apiData.dutyNmKor" readonly disabled />
					</div>
					<div class="block half">
						<label class="text-right">연락처</label>
						<input type="text" name="dutyMobile" v-model="apiData.dutyMobile" readonly disabled />
					</div>
					<div class="block half">
						<label>이메일</label>
						<input type="text" name="dutyEmail" v-model="apiData.dutyEmail" readonly disabled />
					</div>
					<div class="block half">
						<label class="text-right">일반전화</label>
						<input type="text" name="dutyLandline" v-model="apiData.dutyLandline" readonly disabled />
					</div>
				</section>

				<section class="mypage-info-area mt-0" v-show="viewType === 'payment'">
					<h5 class="mobile-hide">기업부담금 납부내역</h5>
					<section class="table-area border-none">
						<div class="table-header mobile-hide" ref="table">
							<div class="col-no">번호</div>
							<div class="col-date">연도</div>
							<div class="col-auto">납부금액</div>
							<div class="col-state">납부상태</div>
							<div class="col-auto">환불사유</div>
							<div class="col-date">납부확인증</div>
							<div class="col-auto">납부일</div>
						</div>
						<!--   web   -->
						<article class="table-list mobile-hide pr-0" v-for="(item, i) in feeList" v-bind:key="'feeList_web' + item.seqNo">
							<div @click="openCompanyDeposit(item.matchSeqNo, item.paymentState)">
								<div class="col-no">
									{{ totalCount - (listPage - 1) * listPageRow - i }}
								</div>
								<div class="col-date">
									{{ item.businessYear }}
								</div>
								<div class="col-auto">
									{{ item.paymentAmount.format() }}
								</div>
								<div class="col-state font-bold">
									<span v-if="item.paymentState == 'PAY'" class="color-blue">납부</span>
									<span v-if="item.paymentState == 'REFUND'">-</span>
									<span v-if="item.paymentState == 'ETC'" class="color-shineGray">기타</span>
									<span v-if="item.paymentState == 'UNPAID' || item.paymentState == null || item.paymentState == ''" class="color-red">미납</span>
								</div>
								<div class="col-auto">
									<span v-if="item.paymentState == 'REFUND'">{{ item.refundReason }}</span>
									<span v-else>-</span>
								</div>
								<div class="col-date">
									<img class="icon-file" :src="require('../../assets/images/icon/icon-file@2x.png')" v-if="item.paymentState === 'PAY'" />
								</div>
								<div class="col-auto">
									<span v-if="item.paymentDate">{{ $moment(item.paymentDate).format('YY.MM.DD') }}</span>
									<span v-else>-</span>
								</div>
							</div>
						</article>
						<!--   mobile   -->
						<article class="table-list web-hide" v-for="(item, i) in feeList" v-bind:key="'feeList_mobile' + item.seqNo">
							<span @click="openCompanyDeposit(item.matchSeqNo, item.paymentState)">
								<div class="col-no mobile-hide">{{ totalCount - (listPage - 1) * listPageRow - i }}</div>
								<div class="col-title">{{ item.paymentAmount.format() }}원</div>
								<div class="col-auto">{{ item.businessYear }}</div>
								<div class="col-state font-bold">
									<span v-if="item.paymentState == 'PAY'" class="color-blue">납부</span>
									<span v-if="item.paymentState == 'REFUND'">-</span>
									<span v-if="item.paymentState == 'ETC'" class="color-shineGray">기타</span>
									<span v-if="item.paymentState == 'UNPAID' || item.paymentState == null || item.paymentState == ''" class="color-red">미납</span>
								</div>
								<div class="col-auto mobile-hide">
									<span v-if="item.paymentState == 'REFUND'">{{ item.refundReason }}</span>
									<span v-else>-</span>
								</div>
								<div class="col-icon">
									<a class="icon-file-before" v-if="item.paymentState === 'PAY'"> | </a>
									<img class="icon-file" :src="require('../../assets/images/icon/icon-file-md@2x.png')" v-if="item.paymentState === 'PAY'" />
								</div>
								<div class="col-auto mobile-hide">
									<span v-if="item.paymentDate">{{ $moment(item.paymentDate).format('YY.MM.DD') }}</span>
									<span v-else>-</span>
								</div>
							</span>
						</article>
					</section>
				</section>
			</form>
		</div>
	</div>
</template>

<script>
import eventBus from '@/plugins/event-bus';
import CONST from '@/constants';

export default {
	title: '내정보변경',
	name: 'Mypage-Detail-Company',
	props: ['loginMember', 'onChange', 'tabType'],
	components: {},
	data: function() {
		return {
			CONST: CONST,
			apiData: [],
			viewType: 'info',
			businessTpNm: '',
			registrationNo: '',

			listPage: 1,
			listPageRow: 10,
			feeList: [],
			totalCount: 0,
		};
	},
	watch: {},
	created() {},
	beforeMount() {
		eventBus.$emit(CONST.EVENTS.SET_SIDE_MENU, 'MYPAGE');
	},
	mounted() {
		this.viewType = this.tabType || 'info';
		eventBus.$on(CONST.EVENTS.SAVE_MYPAGE);
		this.getCompanyDetail();
		this.getCompanyFeeList();
	},
	beforeDestroy() {
		eventBus.$off(CONST.EVENTS.SAVE_MYPAGE);
	},
	computed: {},
	methods: {
		moveTab: function(tab) {
			this.viewType = tab;
		},
		getCompanyDetail: function() {
			this.apiData = [];
			let formData = new FormData();
			formData.append('seqNo', this.loginMember.seqNo);
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/mypage/getCompanyDetail.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						this.apiData = res.data.data;
						this.businessTpNm = this.apiData.businessTpNm != null ? this.apiData.businessTpNm + 'TP' : '';
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
		oktaInfo: function() {
			this.$session.set('userId', this.loginMember.userId);
			this.$device.pushView(CONST.CMS_SERVER + '/mypage/extraList.do' + '?userId=' + this.$apiClient.getApiToken());
		},
		getCompanyFeeList: function() {
			this.feeList = [];
			this.feeCount = 0;
			let formData = new FormData();
			formData.append('companySeqNo', this.loginMember.seqNo);
			formData.append('page', this.listPage);
			formData.append('row', this.listPageRow);
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/business/companyFeeList.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						this.feeList = res.data.data;
						this.totalCount = res.data.dataCount;
						this.registrationNo = this.$options.filters['registrationNoOnly'](this.apiData.registrationNo);
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
		openCompanyDeposit: function(matchSeqNo, paymentState) {
			if (paymentState === 'PAY') {
				this.$session.set('userId', this.loginMember.userId);
				let token = this.$apiClient.getApiToken();
				window.open(CONST.API_SERVER + '/admin/companyDeposit.do' + '?matchSeqNo=' + matchSeqNo + '&userId=' + token);
			} else {
				window.alert('기업부담금이 미납된 항목입니다.');
				return false;
			}
		},
	},
};
</script>

<style scoped></style>
